// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3aiou","title":"Header_title__2fHgf","left":"Header_left__3Pu9O","clinicName":"Header_clinicName__32QIZ"};